export default __webpack_public_path__ + "static/media/github.c0347994.png";